export default __webpack_public_path__ + "static/media/icon-add-to-library-white-new.629d81d5.svg";